import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
// For unknown reason, we need the first import to declare $log on Vue
// and the second to get the correct plugin type
// FROM: https://github.com/justinkames/vuejs-logger/issues/33#issuecomment-602581261
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import VueLoggerPlugin from 'vuejs-logger/dist/vue-logger'

Vue.config.productionTip = false

const isProduction = process.env.NODE_ENV === 'production'

declare module 'vue/types/vue' {
  export interface VueConstructor<V extends Vue = Vue> {
    $log: {
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      debug(...args: any[]): void;
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      info(...args: any[]): void;
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      warn(...args: any[]): void;
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      error(...args: any[]): void;
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      fatal(...args: any[]): void;
    };
  }
}

const logOptions = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
}

Vue.use(VueLoggerPlugin, logOptions)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
